var chevronForward = "https://shopfront-cdn.tekoapis.com/static/a655221bd64cacf4.svg";

export { chevronForward as default };
